import { useCurrentModule } from '../components/ModuleProvider';

/**
 * Whether the current purchase is an initial purchase — i.e. the user has no
 * existing subscription product (as opposed to a change / upgrade / downgrade).
 *
 * The offering fetch is async, so callers must consult `isLoading` before
 * trusting `isInitialPurchase`: while the offering is loading `data` is
 * undefined and `isInitialPurchase` reads as `true`, which is not yet known to
 * be correct. `isError` lets callers fall back to the safe legacy path (treating
 * a failed fetch as a non-initial purchase) rather than committing to V0.
 */
export const useIsInitialPurchase = () => {
  var _data$currentSubscrip;
  const module = useCurrentModule();
  const {
    data,
    isLoading,
    isError
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOffering({});
  return {
    isInitialPurchase: !(data != null && (_data$currentSubscrip = data.currentSubscriptionInfo) != null && _data$currentSubscrip.productId),
    isLoading,
    isError
  };
};
//# sourceMappingURL=useIsInitialPurchase.js.map